<template>
  <div v-if="!isNone">
    <!-- 로그인, 시청하기, 이용권 구매하기, 개별 구매하기-->
    <button type="button" @click.prevent="doAction" class="player-button">{{title}}</button>
  </div>
</template>
<script>
  import { getPermissionForContent } from '@/common/utils/request'
  import _ from 'lodash'
  import { showLoginPopup, showVoucherPopup } from '@/common/utils/scalable.player'
  import cookie from '@/common/utils/cookie'

  const ACTION_STATE = {
    LOGIN: 'login',
    STREAM: 'stream',
    PURCHASE: 'purchase',
    NONE: 'none'
  }
  export default {
    name: 'PlayerActionButton',
    props: {
      contentType: {
        type: String
      },
      contentInfo: {
        type: Object
      }
    },
    data () {
      return {
        title: '',
        action: '',
        isNone: true
      }
    },
    methods: {
      setActionButtonState () {
        const queryObj = { contenttype: this.contentType }
        if (this.contentType === 'vod') {
          const isQVOD = _.get(this.contentInfo, 'type', '') === 'onair'
          if (isQVOD) { queryObj.contenttype = 'qvod' }
          queryObj.contentid = _.get(this.contentInfo, 'contentid', '')
        } else if (this.contentType === 'live') {
          queryObj.contentid = _.get(this.contentInfo, 'channelid', '')
        } else if (this.contentType === 'movie') {
          queryObj.contentid = _.get(this.contentInfo, 'movieid', '')
        }
        getPermissionForContent(queryObj).then(({ data }) => {
          // alert('display : ' + data.display + '/n' + 'action : ' + data.action)
          this.isNone = data.action === ACTION_STATE.NONE
          this.title = data.display
          this.action = data.action
        })
      },
      doAction () {
        switch (this.action) {
          case ACTION_STATE.LOGIN :
            showLoginPopup()
              break
          case ACTION_STATE.STREAM:
            window.playerInstance.play()
            break
          case ACTION_STATE.PURCHASE:
            showVoucherPopup({ type: this.contentType, contentInfo: this.contentInfo })
            break
          case ACTION_STATE.NONE:
            break
        }
      }
    },
    created () {
      if (cookie.isWavveOn()) {
        this.isNone = false
        this.title = '시청하기'
        this.action = ACTION_STATE.STREAM
      } else {
        this.setActionButtonState()
        // const dummyData = {
        //   action: ACTION_STATE.PURCHASE,
        //   display: '구매하기'
        // }
        // this.isNone = dummyData.action === ACTION_STATE.NONE
        // this.title = dummyData.display
        // this.action = dummyData.action
      }
    },
    watch: {
      contentInfo () {
        this.setActionButtonState()
      }
    }
  }
</script>
<style>

</style>
